module.exports = __webpack_public_path__ + "img/banner3_1_kr.7fa00d52.png";